import React from 'react';
import { Card, CardProps } from '@mui/material';

interface ModernCardProps extends CardProps {
  elevated?: boolean;
  glassmorphism?: boolean;
  hover?: boolean;
}

const ModernCard: React.FC<ModernCardProps> = ({
  children,
  elevated = false,
  glassmorphism = true,
  hover = true,
  sx,
  ...props
}) => {
  const getBackground = () => {
    return '#ffffff'; // Always solid white
  };

  const cardStyles = {
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    background: getBackground(),
    boxShadow: elevated
      ? '0 4px 12px rgba(0,0,0,0.1)'
      : '0 1px 3px rgba(0,0,0,0.1)',
    ...sx
  };

  return (
    <Card sx={cardStyles} {...props}>
      {children}
    </Card>
  );
};

export default ModernCard;
